import React from "react";
import { connect } from "react-redux";
import { Route, Switch, withRouter } from "react-router-dom";
import { get } from "lodash";

import HomePage from "./HomePage";
import WorkInProgress from "./WorkInProgress";
import MyAccount from "./MyAccount/MyAccount";
import HspOriginalStatusDashboard from "./Dashboards/HspOriginalStatusDashboard/HspOriginalStatusDashboard";
import HspCurrentStatus from "./Dashboards/HspCurrentStatus/HspCurrentStatus";
import MdcDashboard1 from "./Dashboards/MdcDashboard1/MdcDashboard1";
import MdcDashboard2 from "./Dashboards/MdcDashboard2/MdcDashboard2";
import MdcInventoryDashboard from "./Dashboards/MdcInventoryDashboard/MdcInventoryDashboard";
import OnsiteCounts from "./Dashboards/OnsiteCounts/OnsiteCounts";
import CompanyCounts from "./Dashboards/CompanyCounts/CompanyCounts";
import ProfilesList from "./Profiles/ProfilesList/ProfilesList";
import Profile from "./Profiles/Profile";
import EventsContainer from "./Events/EventsContainer";
import Stats from "./Stats/Stats";
import Stats2 from "./Stats/Stats2";
import Stats3 from "./Stats/Stats3";
import Config from "./Config/Config";
import SiteEntranceExit from "./SiteEntranceExit/SiteEntranceExit";
import Users from "./UsersAndRoles/Users";
import User from "./UsersAndRoles/User";
import Companies from "./Companies/Companies";
import Company from "./Companies/Company";
import IdpContainer from "./Idp/IdpContainer";
import Zone from "./Zones/Zone";
import ImagesList from "../assets/img/ImagesList";
import AddWalkInOutExpress from "./SiteEntranceExit/AddEntry/AddWalkInOutExpress";
import AddDriveInOutFromMenu from "./SiteEntranceExit/AddEntry/AddDriveInOutFromMenu";
import Scheduler from "./Scheduler/Scheduler/Scheduler";
import VMIConfiguration from "./VMI/VMIConfiguration";
import VMIConfigurationMetrics from "./VMI/VMIConfigurationMetrics";
import { roles } from "../constants/roles";

import { driveInOut, trainInOut, walkInOut } from "../constants/reducers";
import { isAllowed } from "../utils/users";
import { HSP, MDC } from "../constants/common";
import SchedulerMDC from "./Scheduler/Scheduler/SchedulerMDC";

import VMIrequests from "./VMI/Requests";
import VMITable from "./VMI/VMITable";
import WMSInventory from "./VMI/WMSInventory";
import WMSProductLookup from "./VMI/ProductLookup"
import POReplacement from "./VMI/POReplacement";

const Router = (props) => {
  const { solutionsAccess, permissions, profileID } = props;

  // Access bloqued to policy page until acceptance
  if (props.policyAccessDenied) {
    if (props.location.pathname !== "/profiles/me/dataPrivacy") {
      props.history.push("/profiles/me/dataPrivacy");
    }
    return (
      <Switch>
        <Route path="/profiles/me/:profileSection" component={Profile} />
        <Route component={Profile} />
      </Switch>
    );
  }
  const level = get(props, ["userRole", "level"]);
  return (
    <Switch>
      {/* Home Page */}
      <Route exact path="/" component={HomePage} />

      {/* Me profile */}
      <Route exact path="/profiles/me" component={Profile} />
      <Route path="/profiles/me/:profileSection" component={Profile} />

      <Route exact path={"/profiles/"+profileID} component={Profile} />

      <Route exact path={"/vmi-selector"} component={VMIConfiguration} />

      {/* IDP */}
      {level < roles.user && get(solutionsAccess, ["IDP", "allow"]) && <Route exact path="/idp" component={IdpContainer} />}

      {/* Human Access */}
      {level < roles.user && get(solutionsAccess, ["HSP", "allow"]) && <Route exact path="/siteEntranceExit/walkInOut" render={() => <SiteEntranceExit section={walkInOut} />} />}
      {level < roles.user && get(solutionsAccess, ["HSP", "allow"]) && <Route exact path="/siteEntranceExit/walkInOut/site/:siteId" render={() => <SiteEntranceExit section={walkInOut} />} />}
      {level < roles.user && get(solutionsAccess, ["HSP", "allow"]) && <Route exact path="/siteEntranceExit/walkInOut/site/:siteId/zone/:zoneId" render={() => <SiteEntranceExit section={walkInOut} />} />}
      {level < roles.user && get(solutionsAccess, ["HSP", "allow"]) && <Route exact path="/siteEntranceExit/walkInOut/site/:siteId/eventGroup/:eventGroupId" render={() => <SiteEntranceExit section={walkInOut} />} />}
      {level < roles.user && get(solutionsAccess, ["HSP", "allow"]) && <Route exact path="/hsp/new/walkIn" render={() => <AddWalkInOutExpress eventGroupType={4} />} />}
      {level < roles.user && get(solutionsAccess, ["HSP", "allow"]) && <Route exact path="/hsp/new/walkOut" render={() => <AddWalkInOutExpress eventGroupType={5} />} />}

      {/* Scheduler */}
      {get(solutionsAccess, ["HSP", "allow"]) && isAllowed(permissions, "schedules.read") && <Route exact path="/scheduler/hsp" render={() => <Scheduler type={HSP} />} />}
      {get(solutionsAccess, ["MDC", "allow"]) && isAllowed(permissions, "schedules.read") && <Route exact path="/scheduler/mdc" render={() => <SchedulerMDC type={MDC} />} />}
      
      {/* Dashboards */}
      {level < roles.other && get(solutionsAccess, ["HSP", "allow"]) && <Route path="/dashboards/hspOriginalStatus" component={HspOriginalStatusDashboard} />}
      {level < roles.other && get(solutionsAccess, ["HSP", "allow"]) && <Route path="/dashboards/hspCurrentStatus" component={HspCurrentStatus} />}
      {level < roles.customerAdmin && get(solutionsAccess, ["MDC", "allow"]) && <Route path="/dashboards/mdcDashboard1" component={MdcDashboard1} />}
      {level < roles.customerAdmin && get(solutionsAccess, ["MDC", "allow"]) && <Route path="/dashboards/mdcDashboard2" component={MdcDashboard2} />}
      {level <= roles.customerAdmin && <Route path="/dashboards/mspMonthlyTransactionalStats" component={Stats3} />}
      {level <= roles.customerAdmin && <Route path="/dashboards/mdcInventoryDashboard" component={MdcInventoryDashboard} />}
      {level <= roles.customerAdmin && <Route path="/dashboards/onsiteCounts" component={OnsiteCounts} />}
      {level <= roles.customerAdmin && <Route path="/dashboards/companyCounts" component={CompanyCounts} />}
      {level <= roles.customerAdmin && <Route path="/dashboards/vmiConfigurationMetrics" component={VMIConfigurationMetrics} />}

      {/* Profile Creation */}
      {level <= roles.customerAdmin && <Route exact path="/profiles/creation/:type" component={ProfilesList} />}

      {/* Any profile details */}
      {level < roles.user && <Route exact path="/profiles/:id3" component={Profile} />}
      {level < roles.user && <Route path="/profiles/:id3/:profileSection" component={Profile} />}

      {/* Vehicle Access */}
      {level <= roles.customerAdmin && get(solutionsAccess, ["MDC", "allow"]) && <Route exact path="/siteEntranceExit/driveInOut" render={() => <SiteEntranceExit section={driveInOut} />} />}
      {level <= roles.customerAdmin && get(solutionsAccess, ["MDC", "allow"]) && <Route exact path="/siteEntranceExit/driveInOut/site/:siteId" render={() => <SiteEntranceExit section={driveInOut} />} />}
      {level <= roles.customerAdmin && get(solutionsAccess, ["MDC", "allow"]) && <Route exact path="/siteEntranceExit/driveInOut/site/:siteId/zone/:zoneId" render={() => <SiteEntranceExit section={driveInOut} />} />}
      {level <= roles.customerAdmin && get(solutionsAccess, ["MDC", "allow"]) && <Route exact path="/siteEntranceExit/driveInOut/site/:siteId/eventGroup/:eventGroupId" render={() => <SiteEntranceExit section={driveInOut} />} />}
      {level <= roles.customerAdmin && get(solutionsAccess, ["MDC", "allow"]) && <Route exact path="/mdc/new/driveIn" render={() => <AddDriveInOutFromMenu eventGroupType={2} />} />}
      {level <= roles.customerAdmin && get(solutionsAccess, ["MDC", "allow"]) && <Route exact path="/mdc/new/driveOut" render={() => <AddDriveInOutFromMenu eventGroupType={3} />} />}

      {/* Admin section */}
      {level <= roles.customerAdmin && <Route exact path="/admin/companies" component={Companies} />}
      {level <= roles.customerAdmin && <Route exact path="/admin/companies/:companyId/:tab?" component={Company} />}
      {level <= roles.customerAdmin && <Route exact path="/admin/companies/:companyId/sites/:siteId/:tab?" component={Company} />}
      {level <= roles.customerAdmin && <Route exact path="/admin/companies/:companyId/sites/:siteId/zones/:zoneId/:tab?" component={Company} />}
      {level <= roles.customerAdmin && <Route exact path="/admin/companies/:companyId/sites/:siteId/zones/:zoneId/devices/:deviceId/:tab?" component={Company} />}
      {level <= roles.customerAdmin && <Route exact path="/admin/users" component={Users} />}
      {level <= roles.customerAdmin && <Route path="/admin/users/:id4" component={User} />}
      {level <= roles.customerAdmin && <Route path="/admin/config/:tab" component={Config} />}
      {level <= roles.customerAdmin && <Route path="/admin/config" component={Config} />}

      {/* Warehouse Manangement System section */}
      {level <= roles.user && get(solutionsAccess, ["WMS", "allow"]) && <Route exact path="/wms/requests/:id" component={VMIrequests} />}
      {level <= roles.user && get(solutionsAccess, ["WMS", "allow"]) && <Route exact path="/wms/requests_orders/:tab?" component={VMITable} />}
      {level <= roles.customerAdmin && get(solutionsAccess, ["WMS", "allow"]) && <Route exact path="/wms/vmi-configuration/:zoneId" component={Zone} />}
      {level <= roles.user && get(solutionsAccess, ["WMS", "allow"]) && <Route exact path="/wms/inventory" component={WMSInventory} />}
      {level <= roles.user && get(solutionsAccess, ["WMS", "allow"]) && <Route exact path="/wms/lookup" component={WMSProductLookup} />}
      {level <= roles.user && get(solutionsAccess, ["WMS", "allow"]) && <Route exact path="/wms/po-search" component={POReplacement} />}


      {/* 
      {level <= roles.customerAdmin && <Route exact path="/wms/requests/:id" component={VMIrequests} />}
      {level <= roles.customerAdmin && <Route exact path="/wms/company/:id/requests/sectors" component={VMITable} />}
      {level <= roles.customerAdmin && <Route exact path="/wms/company/:id/requests/list" component={VMITable} />}
      {level <= roles.customerAdmin && <Route exact path="/wms/company/:id/requests/edit/:id" component={VMITable} />}
      {level <= roles.customerAdmin && <Route exact path="/wms/company/:id/requests/search" component={VMITable} />}
      {level <= roles.customerAdmin && <Route exact path="/wms/company/:id/requests/qrscan" component={VMITable} />} 
      */}

      {/* Train Manifest */}
      {level <= roles.user && get(solutionsAccess, ["TVS", "allow"]) && <Route exact path="/siteEntranceExit/trainInOut" render={() => <SiteEntranceExit section={trainInOut} />} />}
      {level <= roles.user && get(solutionsAccess, ["TVS", "allow"]) && <Route exact path="/siteEntranceExit/trainInOut/site/:siteId" render={() => <SiteEntranceExit section={trainInOut} />} />}
      {level <= roles.user && get(solutionsAccess, ["TVS", "allow"]) && <Route exact path="/siteEntranceExit/trainInOut/site/:siteId/zone/:zoneId" render={() => <SiteEntranceExit section={trainInOut} />} />}
      {level <= roles.user && get(solutionsAccess, ["TVS", "allow"]) && <Route exact path="/siteEntranceExit/trainInOut/site/:siteId/eventGroup/:eventGroupId" render={() => <SiteEntranceExit section={trainInOut} />} />}

      {/* Events Section  */}
      {level <= roles.customerAdmin && <Route exact path="/events" component={EventsContainer} />}
      {level <= roles.customerAdmin && <Route exact path="/events/:tab2" component={EventsContainer} />}
      {level <= roles.customerAdmin && <Route path="/events/:tab2/:selected" component={EventsContainer} />}

      {/* Profiles List */}
      {level <= roles.customerAdmin && <Route exact path="/profiles" component={ProfilesList} />}

      {/* Stats */}
      <Route exact path="/stats" component={Stats} />
      <Route path="/stats2" component={Stats2} />
      <Route path="/stats3" component={Stats3} />

      <Route path="/imagesList" component={ImagesList} />

      <Route path="/myAccount" component={MyAccount} />
      <Route component={WorkInProgress} />
    </Switch>
  );
};

const mapStateToProps = (state) => {
  return {
    solutionsAccess: get(state, ["user", "solutionsAccess"]),
    permissions: get(state, ["user", "permissions"]),
  };
};

export default withRouter(connect(mapStateToProps)(Router));
